import http from '@/services/rest/rest.service';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import { IChatLogListModel } from '@/entities/chat-logs/chat-log-list-model.interface';
import { IChatLogSubmitModel } from '@/entities/chat-logs/chat-log-submit-model.interface';

export default {
    list(body: ISearchBody): Promise<IPaging<IChatLogListModel>> {
        return http.post('chat-logs/search', body);
    },
    submit(body: IChatLogSubmitModel): Promise<number> {
        return http.put('chat-logs/', body);
    }
};
